"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _CountryPicker = require("./CountryPicker.desktop");
var _CountryPicker2 = require("./CountryPicker.mobile");
var CountryPicker = function CountryPicker(props) {
  var isMobile = props.isMobile;
  return isMobile ? /*#__PURE__*/_react["default"].createElement(_CountryPicker2.CountryPickerMobile, props) : /*#__PURE__*/_react["default"].createElement(_CountryPicker.CountryPickerDesktop, props);
};
var _default = exports["default"] = CountryPicker;